import React, { createContext, useState, useContext, useEffect } from 'react';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [cars, setCars] = useState([]);

  // Load cars and admin status from localStorage
  useEffect(() => {
    const savedCars = localStorage.getItem('sahaCars');
    if (savedCars) {
      setCars(JSON.parse(savedCars));
    }
    
    const adminStatus = localStorage.getItem('isAdmin');
    if (adminStatus === 'true') {
      setIsAdmin(true);
    }
  }, []);

  const login = (username, password) => {
    if (username === 'admin' && password === 'saha2026') {
      setIsAdmin(true);
      localStorage.setItem('isAdmin', 'true');
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAdmin(false);
    localStorage.removeItem('isAdmin');
  };

  const addCar = (car) => {
    const newCar = { ...car, id: Date.now().toString() };
    const updatedCars = [...cars, newCar];
    setCars(updatedCars);
    localStorage.setItem('sahaCars', JSON.stringify(updatedCars));
  };

  const updateCar = (id, updatedCar) => {
    const updatedCars = cars.map(car => car.id === id ? updatedCar : car);
    setCars(updatedCars);
    localStorage.setItem('sahaCars', JSON.stringify(updatedCars));
  };

  const deleteCar = (id) => {
    const updatedCars = cars.filter(car => car.id !== id);
    setCars(updatedCars);
    localStorage.setItem('sahaCars', JSON.stringify(updatedCars));
  };

  return (
    <AdminContext.Provider value={{
      isAdmin,
      login,
      logout,
      cars,
      addCar,
      updateCar,
      deleteCar
    }}>
      {children}
    </AdminContext.Provider>
  );
};